// extracted by mini-css-extract-plugin
export default {"container":"RateForm-module__container--95fb","fields":"RateForm-module__fields--d542"};